import type { ApiConfig, UrlDespatchOption } from "./Http.d";

/**
 * Get the Url based on the environment
 */
export default class UrlDespatch {
  static apiConfig: ApiConfig;
  static debugData: string;
  static environment: string;
  static env: any;
  constructor(option: UrlDespatchOption) {
    this.init(option);
  }

  init(option: UrlDespatchOption): void {
    UrlDespatch.apiConfig = option.apiConfig;
    UrlDespatch.debugData = option.debugData;
    UrlDespatch.environment = option.env.REACT_APP_ENV;
    UrlDespatch.env = option.env;
  }

  getUrl(path: string): string | undefined {
    const api = UrlDespatch.apiConfig.apis[path];
    if (!api) {
      return undefined;
    }
    let url = "";
    switch (UrlDespatch.environment) {
      case "development":
        return api.serve;
      case "debug":
        return api.path;
      default:
        if (api.customeHost) {
          url = api.customeHost![UrlDespatch.environment] + api.path;
        } else {
          url =
            UrlDespatch.apiConfig.defaultHost[UrlDespatch.environment] +
            api.path;
          console.log('getUrl api.path', api.path)
          console.log('getUrl url', url)
        }
        return url;
    }
  }
}
